export const VIDEO_ACCOUNT_TYPES = ['GOOGLE'];
